import React, { useState, useEffect } from "react";
import {
    List, Datagrid, TextField, FunctionField, SimpleList
} from "react-admin";
import { makeStyles, useMediaQuery, Typography, Switch, Dialog, DialogContent, DialogActions, Button, MenuItem, IconButton, InputBase } from "@material-ui/core";
import Skeleton from '@material-ui/lab/Skeleton';
import ScrollableTable from './components/ScrollableTable';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import { customTheme } from "./customTheme";
import config from "./config.json";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import { styled } from '@material-ui/core/styles';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    list: {
        marginBottom: 40,
    },
    relativePosition: {
        position: "relative",
        verticalAlign: "initial"
    },
    fixedInventoryDetails: {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "14px 12px",
        borderTop: "1px solid #e5e5e5",
        zIndex: 1,
        "&:hover": {
            cursor: "default"
        }
    }
});
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: 1000,
    backgroundColor: "#f5f5f5",
    flex: 1,
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
    width: "100%",
    padding: "6px 0 6px 55px",
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));

function StatusToggle(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, resource, basePath } = props;
        const data = {
            ...record,
            [source]: !record[source]
        };
        dispatchCrudUpdate(resource, record.id, data, record, basePath, `/${resource}`);
    };

    return (
        <div style={{ textAlign: "left", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            {isSmallDevice && <Typography style={{ fontSize: 15 }}>Approval:</Typography>}
            <Switch color={Boolean(record[source]) ? "primary" : "default"} disabled={props.disabled} checked={Boolean(record[source])} onChange={openDialog} />

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>Are you sure you want to {record[source] ? "Deactivate" : "Activate"} this Operator User?</DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={handleUpdate}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
StatusToggle.defaultProps = {
    redirect: 'list',
    undoable: false
};
const CustomStatusToggle = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(StatusToggle);

/* Inventory Home */
const InventoryUserSkeletonLoader1 = props => <Skeleton variant="text" height={18} width={160} style={{ display: "inline-block", transform: "none" }} {...props} />;
function InventoryUserDetails(props) {
    const { record } = props;
    //const notify = useNotify();

    const [devices, setDevices] = useState(null);
    const [deviceListVisible, setDeviceListVisible] = useState(false);
    const [deviceFilter, setDeviceFilter] = useState("");

    let filteredDevices;
    if (devices)
        filteredDevices = devices.filter(device => device.serial_number.includes(deviceFilter));

    const openDevicesList = () => {
        setDeviceListVisible(true);
        fetch(`${config.HOST_NAME}/crm/v3/inventoryDevices?warrior_user_id=${record["id"]}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    setDevices(json.data);
                } else {
                    notify(json.message);
                }
            }).catch((e) => {
                notify('Could not fetch inventory devices', 'warning');
            });
    };

    const closeDevicesList = () => {
        setDeviceListVisible(false);
    };

    useEffect(() => {
        if (record) {

        }
    }, [record]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!record) return null;
    return (
        <div style={{ display: "grid", gridTemplateColumns: `repeat(auto-fill, minmax(300px, 1fr))`, width: "100%", columnGap: 12, rowGap: 7 }}>
            {["devices", "bags", "rolls", "monthly_card", "bluetooth_printer", "tempered_glass", "led", "charger", "charging_wire"].map(key => (
                key === "devices" ?
                    <Typography
                        key={key}
                        className="divButton"
                        style={{ textTransform: "capitalize", minWidth: 120, width: "100%", flex: 1, maxWidth: 300, display: "flex", alignItems: "center", color: customTheme.palette.primary.main }}
                        onClick={openDevicesList}
                    >
                        {key.replace("_", " ")}: {record[key]}
                    </Typography>
                    :
                    <Typography key={key} style={{ textTransform: "capitalize", minWidth: 120, width: "100%", flex: 1, maxWidth: 300, display: "flex", alignItems: "center" }}>{key.replace("_", " ")}: {record[key]}</Typography>
            ))}


            <Dialog fullWidth open={deviceListVisible} onClose={closeDevicesList}>
                <div style={{ display: "flex", columnGap: 12, margin: "10px 20px 20px" }}>
                    <Search>
                        <SearchIconWrapper><SearchIcon /></SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            value={deviceFilter}
                            onChange={e => setDeviceFilter(e.target.value)}
                        />
                    </Search>
                    <IconButton onClick={closeDevicesList}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div style={{ overflowY: "auto", paddingBottom: 10 }}>
                    {filteredDevices ?
                        (filteredDevices.length > 0 ?
                            filteredDevices.map(device => (
                                <MenuItem key={device.serial_number} style={{ paddingLeft: 30, paddingRight: 30 }}>
                                    <div>
                                        <div>{device.serial_number}</div>
                                        <div style={{ color: "#777" }}>{device.device_type}</div>
                                    </div>
                                </MenuItem>
                            ))
                            :
                            <Typography style={{ padding: "5px 30px 30px", color: "#777", textAlign: "center" }}>No devices to show</Typography>
                        )
                        :
                        ["33%", "40%", "30%"].map((width, index) => (
                            <MenuItem key={index}>
                                <InventoryUserSkeletonLoader1 width={width} />
                            </MenuItem>
                        ))
                    }
                </div>
            </Dialog>
        </div>
    );
}
export function InventoryHome(props) {

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const classes = useStyles();

    return <div className={classes.list}>
        <List
            {...props}
            title="Inventory Home"
            bulkActionButtons={false}
            sort={{ field: "name", order: "ASC" }}
            exporter={false}
            empty={false}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => record["name"]}
                    secondaryText={record => (<div>
                        <div>{record["mobile"] ? `Mob No: ${record["mobile"]}` : ""}</div>
                        <div>{record["user_type"] ? `Role: ${record["user_type"]}` : ""}</div>

                    </div>)}
                    rightIcon={record => <CustomStatusToggle {...props} record={record} source="approved" label="Approval" disabled={true} />}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid rowClick="expand" expand={<InventoryUserDetails />} component={ScrollableTable} classes={{ row: classes.relativePosition }} isRowExpandable={record => !(record["user_type"] === "warehouse")}>
                    <TextField source="name" label="Name" />
                    <TextField source="mobile" label="Mobile Number" />
                    <FunctionField
                        sortable
                        source="user_type"
                        label="Role"
                        render={record => (<div style={{ paddingBottom: record["user_type"] === "warehouse" ? 120 : undefined }}>
                            {typeof record["user_type"] === "string" ? record["user_type"].replace(/_/g, " ") : ""}
                            {record["user_type"] === "warehouse" ? <div className={classes.fixedInventoryDetails}><InventoryUserDetails record={record} /></div> : null}
                        </div>)}
                        style={{ textTransform: "capitalize" }} />
                    <CustomStatusToggle source="approved" label="Approval" disabled={true} />
                </Datagrid>
            }
        </List>
    </div>
}